import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './paidToTwcModal.entrypoint';

export function PaidToTwcModal(): React.JSX.Element {
	const { formatMessage } = useIntl();
	const entryPointParams = useMemo(() => ({}), []);
	const modalProps = useMemo(
		() => ({
			width: '1116px',
			height: '733px',
			shouldScrollInViewport: false,
			shouldCloseOnEscape: true,
			label: formatMessage({
				id: '@atlassian/edition-awareness.dialog.paid-to-twc.label',
				defaultMessage: 'Teamwork Collection plan comparison',
				description: 'Accessible name for the Teamwork Collection comparison dialog.',
			}),
		}),
		[formatMessage],
	);

	return (
		<ModalEntryPoint
			modalProps={modalProps}
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
